import { Box, Divider, Tab, Tabs } from '@mui/material';
import { CLIENT_FORM_ROUTES, ROUTING_CONFIG } from '@uplift/constants';
import { Loader } from '@uplift/ui-v2';
import React from 'react';
import { MemoryRouter, Redirect, Route, Switch, useLocation } from 'react-router';
import { HistoryTab } from './HistoryTab';
import { AdministerTab } from './AssessmentsTab';
import { AssessmentForm } from './AssessmentForm';
import { TrendsTab } from './TrendsTab';


export type AssessmentsAdministrationProps = {
  sessionId: string;
  patientId: string;
};


const AssessmentsAdministrationRoot: React.FC<AssessmentsAdministrationProps> = (props) => {
  const [ tab, setTab ] = React.useState('administer');

  return (
    <Box>
      <Tabs value={tab} onChange={(_, value) => setTab(value)} variant="fullWidth">
        <Tab label="Administer" value="administer" />
        {/* <Tab label="Trend" value="trend" /> */}
        <Tab label="History" value="history" />
      </Tabs>
      <Divider />
      {tab === 'administer' && (
        <React.Suspense fallback={<Loader minHeight="300px" />}>
          <AdministerTab patientId={props.patientId} />
        </React.Suspense>
      )}
      {tab === 'trend' && (
        <React.Suspense fallback={<Loader minHeight="300px" />}>
          <TrendsTab patientId={props.patientId} />
        </React.Suspense>
      )}
      {tab === 'history' && (
        <React.Suspense fallback={<Loader minHeight="300px" />}>
          <HistoryTab patientId={props.patientId} />
        </React.Suspense>
      )}
    </Box>
  );
};


const AnyRoute = () => {
  const location = useLocation();

  return (
    <Box>
      Hello there! {location.pathname}
    </Box>
  );
};


export const AssessmentsAdministration: React.FC<AssessmentsAdministrationProps> = React.memo((props) => {
  return (
    <MemoryRouter>
      <Switch>
        <Route exact path="/">
          <AssessmentsAdministrationRoot {...props} />
        </Route>

        <Route exact path={[ ...CLIENT_FORM_ROUTES, ROUTING_CONFIG.formBySubmission ]}>
          <AssessmentForm />
        </Route>

        <Route
          exact
          path={[ ROUTING_CONFIG.nextAssessment, ROUTING_CONFIG.main ]}
        >
          <Redirect to="/" />
        </Route>

        <Route path="*">
          <AnyRoute />
        </Route>
      </Switch>
    </MemoryRouter>
  );
});
